<template>
  <div class="absolute bottom-0 left-0 p-4">
    <div class="flex flex-row space-x-5">
      <button
        class="flex items-center justify-center p-2 text-sm text-gray-500 bg-white rounded-lg shadow-lg"
        @click="openPhotoModal()"
      >
        <span class="">Show {{ property.photos.length }} photos</span>
      </button>
      <button
        class="flex items-center justify-center p-2 text-sm text-gray-500 bg-white rounded-lg shadow-lg"
        @click="openViewModal()"
      >
        <span class="">View on map</span>
      </button>
      <MapModal
        :address="address"
        :showViewModal="showMapModal"
        @closeViewModal="closeModal"
      />
      <PhotoModal
        :photos="property.photos"
        :showViewModal="showPhotoModal"
        @closePhotoModal="closePhotoModal"
      />
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
// import { useStore } from "vuex";
import MapModal from "./MapModal.vue";
import PhotoModal from "./PhotosSliderModal.vue";

export default {
  props: {
    property: Object,
    address: String,
  },
  components: {
    MapModal,
    PhotoModal,
  },
  setup() {
    const showModal = ref(false);
    const showMapModal = ref(false);
    const showPhotoModal = ref(false);

    // const store = useStore();

    const openViewModal = () => {
      showMapModal.value = true;
    };

    const openPhotoModal = () => {
      showPhotoModal.value = true;
    };

    const closeModal = () => {
      showMapModal.value = false;
    };

    const closePhotoModal = () => {
      showPhotoModal.value = false;
    };

    return {
      showModal,
      showMapModal,
      showPhotoModal,
      openViewModal,
      closeModal,
      openPhotoModal,
      closePhotoModal,
    };
  },
};
</script>
